import React, {useState} from 'react';
import {NavLink, Outlet, useLocation, useNavigate} from 'react-router-dom';
import {useMemberWallet} from "../../hooks/useMemberWallet";
import {SearchTypes} from "../../types/common/search.types";
import SearchDateSelect from "../../components/common/SearchDateSelect";
import {setNewSearchType} from "../../utils/search";
import {defaultConfirm} from "../../utils/alert";
import {AccountArea} from "../../components/bank/AccountArea";
import {useAccountNavigation} from "../../hooks/useAccountNavigation";
import {BalanceArea} from "../../components/bank/BalanceArea";


export default function Wallet() {
    const navigate = useNavigate();
    const location = useLocation();

    const {memberWalletInfo, loading, error, refetch} = useMemberWallet();
    const handleChargeClick = () => navigate('/wallet/charge');
    const handleRefundClick = () => {
        if (memberWalletInfo?.accountNo == null) {
            defaultConfirm("환불계좌가 등록되어 있지\n않습니다.\n환불계좌를 등록 후 잔액환불\n신청을 진행해주세요.", "계좌 등록하기", "닫기",
                (isConfirmed) => {
                    if (isConfirmed) {
                        navigate('/wallet/accountVerification');
                    } else {
                        return;
                    }
                }
            );
        } else {
            navigate('/wallet/refund');
        }
    };

    //------------- 리스트 조회 함수 모음 start ------------------
    const [totalSize, setTotalSize] = useState(0);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [searchTypes, setSearchTypes] = useState<SearchTypes>(
        setNewSearchType()
    );
    const handleSearch = () => {
        setSearchTypes(prev => ({
            ...prev,
            page: 1
        }));
        setSearchTrigger(prev => prev + 1);
    };
    const handleStartDateChange = (date: string) => {
        setSearchTypes(prev => ({...prev, startDate: date}));
    };
    const handleEndDateChange = (date: string) => {
        setSearchTypes(prev => ({...prev, endDate: date}));
    };
    const handleReset = () => {
        setSearchTypes(
            setNewSearchType()
        );
    };
    //------------- 리스트 조회 함수 모음 end ------------------

    return (
        <main className="container type_gray">
            {/* 보유 금액 섹션 */}
            <section className="bg-white">
                <div className="inner-top">
                    <h3 className="username">
                        <strong>{memberWalletInfo?.memberName}</strong>님, 반갑습니다.
                    </h3>

                    <BalanceArea
                        className={"sub-wallet"}
                        title={"보유 잔액"}
                        balance={Number(memberWalletInfo?.prepaidBalance || 0)}
                        expectedBalance={memberWalletInfo?.expectedBalance || 0}
                        expectedBalanceShow={true}
                    />

                    <AccountArea
                        className={"account-bar"}
                        accountNo={memberWalletInfo?.accountNo}
                        bankName={memberWalletInfo?.bankName}
                    />

                </div>
            </section>

            {/* 메뉴 아이콘 섹션 */}
            <section className="bg-white no-gap">
                <div className="inner-box">
                    <div className="round-box">
                        <ul className="menu-icon-list">
                            <li>
                                <a onClick={handleChargeClick}>
                                    <div className="menu-ico1"></div>
                                    <h4>충전하기</h4>
                                </a>
                            </li>
                            <li>
                                <a onClick={handleRefundClick}>
                                    <div className="menu-ico2"></div>
                                    <h4>잔액환불신청</h4>
                                </a>
                            </li>
                            <li>
                                <a onClick={useAccountNavigation(memberWalletInfo?.accountNo)}>
                                    <div className="menu-ico3"></div>
                                    <h4>계좌관리</h4>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="bg-white">
                <div className="inner-box">
                    <form method="post" className="form-box">
                        <fieldset>
                            <legend></legend>
                            <div className="form-item">
                                <div
                                    style={{
                                        overflowX: 'auto',
                                        WebkitOverflowScrolling: 'touch',
                                        msOverflowStyle: 'none',
                                        scrollbarWidth: 'none',
                                        width: '100%',
                                    }}
                                >
                                    <div className="radio-row" style={{flexWrap: 'nowrap', minWidth: 'max-content'}}>
                                        <span className="text-radio">
                                            <NavLink
                                                to="all-list"
                                                replace
                                                className={({isActive}) => (isActive ? "active" : "")}
                                            >
                                                <input
                                                    type="radio"
                                                    id="radio-all"
                                                    name="offer"
                                                    value="all-list"
                                                    checked={location.pathname.includes("all-list")}
                                                    readOnly
                                                />
                                                <label htmlFor="radio-all">전체</label>
                                            </NavLink>
                                        </span>
                                        <span className="text-radio">
                                            <NavLink
                                                to="charge-list"
                                                replace
                                                className={({isActive}) => (isActive ? "active" : "")}
                                            >
                                                <input
                                                    type="radio"
                                                    id="radio-charge"
                                                    name="offer"
                                                    value="charge-list"
                                                    checked={location.pathname.includes("charge-list")}
                                                    readOnly
                                                />
                                                <label htmlFor="radio-charge">충전</label>
                                            </NavLink>
                                        </span>
                                        <span className="text-radio">
                                            <NavLink
                                                to="use-list"
                                                replace
                                                className={({isActive}) => (isActive ? "active" : "")}
                                            >
                                                <input
                                                    type="radio"
                                                    id="radio-use"
                                                    name="offer"
                                                    value="use-list"
                                                    checked={location.pathname.includes("use-list")}
                                                    readOnly
                                                />
                                                <label htmlFor="radio-use">사용</label>
                                            </NavLink>
                                        </span>
                                        <span className="text-radio">
                                            <NavLink
                                                to="refund-list"
                                                replace
                                                className={({isActive}) => (isActive ? "active" : "")}>
                                                <input
                                                    type="radio"
                                                    id="radio-refund"
                                                    name="offer"
                                                    value="refund-list"
                                                    checked={location.pathname.includes("refund-list")}
                                                    readOnly
                                                />
                                                <label htmlFor="radio-refund">잔액환불</label>
                                            </NavLink>
                                        </span>
                                        <span className="text-radio">
                                            <NavLink
                                                to="expired-list"
                                                replace
                                                className={({isActive}) => (isActive ? "active" : "")}>
                                                <input
                                                    type="radio"
                                                    id="radio-expired"
                                                    name="offer"
                                                    value="expired-list"
                                                    checked={location.pathname.includes("expired-list")}
                                                    readOnly
                                                />
                                                <label htmlFor="radio-expired">기간만료</label>
                                            </NavLink>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <SearchDateSelect
                                startDate={searchTypes.startDate}
                                endDate={searchTypes.endDate}
                                onStartDateChange={handleStartDateChange}
                                onEndDateChange={handleEndDateChange}
                                maxMonths={3}
                            />

                            <div className="form-item mt10">
                                <div className="form-btn">
                                    <button
                                        type="button"
                                        className="line-btn"
                                        onClick={handleReset}>초기화
                                    </button>
                                    <button
                                        type="button"
                                        className="submit-btn"
                                        onClick={handleSearch}>검색
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div className="inner-box">
                    <p className="total">
                        총 <span className="point">{totalSize}</span>건의 내역이 조회되었습니다.
                    </p>
                </div>
            </section>

            <Outlet context={{searchTypes, setTotalSize, searchTrigger}}/>
        </main>
    );
};
